import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Stepper } from "@/components/booking/Stepper";
import { StepService } from "@/components/booking/StepService";
import { StepPackage } from "@/components/booking/StepPackage";
import { StepCustomize } from "@/components/booking/StepCustomize";
import { StepTerm } from "@/components/booking/StepTerm";
import { StepDetails } from "@/components/booking/StepDetails";
import { BookingSuccess } from "@/components/booking/BookingSuccess";

const STEP_NUM = { service: 1, package: 2, customize: 2, term: 3, details: 3 };
const VIEWS = { service: StepService, package: StepPackage, customize: StepCustomize, term: StepTerm, details: StepDetails };

export default function BookingPage() {
  const [config, setConfig] = useState(null);
  const [step, setStep] = useState("service");
  const [done, setDone] = useState(null);
  const [b, setB] = useState({ service: null, car: "sedan", packageId: null, addons: [], date: null, time: null });

  useEffect(() => { api.get("/config").then((r) => setConfig(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, [step, done]);

  const update = (p) => setB((s) => ({ ...s, ...p }));
  const pkg = config?.packages.find((p) => p.id === b.packageId);
  const chosenAddons = config?.addons.filter((a) => b.addons.includes(a.id)) || [];
  const total = pkg ? pkg.prices[b.car] + chosenAddons.reduce((s, a) => s + a.price, 0) : 0;
  const ctx = { config, b, update, pkg, chosenAddons, total, go: setStep, setDone };
  const View = VIEWS[step];

  return (
    <div className="relative min-h-screen grain overflow-hidden">
      <div className="fixed inset-0 -z-10">
        <img src="/img/bg-rear.webp" alt="" className="w-full h-full object-cover opacity-[0.16]" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/90 to-background" />
      </div>
      <header className="max-w-6xl mx-auto px-5 sm:px-8 pt-6 flex items-center justify-between gap-4">
        <Logo className="h-14 sm:h-16" />
        {!done && <Stepper current={STEP_NUM[step]} />}
      </header>
      <main className="max-w-6xl mx-auto px-5 sm:px-8 py-10 sm:py-14">
        {!config ? <div data-testid="booking-loading" className="text-muted-foreground">Ładowanie...</div>
          : done ? <BookingSuccess booking={done} /> : <View ctx={ctx} />}
      </main>
    </div>
  );
}
